import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anonymous

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    api.get("/auth/me").then(({ data }) => setUser(data)).catch(() => { setToken(null); setUser(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const acceptInvite = useCallback(async (payload) => {
    const { data } = await api.post("/auth/accept-invite", payload);
    setToken(data.token);
    setUser(data.user);
    return data.user;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    setToken(null);
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, setUser, login, logout, acceptInvite }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
export const isStaff = (user) => !!user && user.role !== "client";
export const isManager = (user) => !!user && ["super_admin", "admin"].includes(user.role);
export const homeFor = (user) => (!user ? "/login" : user.role === "client" ? "/client" : "/admin");
